<div>
    <div style="margin-left: 70%;  margin-bottom: 2%">
        <!-- <button class="btn btn-info" mat-raised-button (click)="assigndisrep()">
                Add Distribution Rep.
            </button> -->
        <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printSectionId="print-section" ngxPrint>
            print
        </button>
        <button type="button" mat-raised-button matTooltip="Download Excel sheet" class="btn btn-danger"
            (click)="exportExcel('bank_report_details')" style="margin-right: 10px;">
            Export
        </button>
        <button mat-dialog-close class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div class="wrapper">
            <div class="row rowborder rowbordertop">
                <div class="common" style="margin-left: 20px;">
                    <span>दिनांक : 31/03/2023</span>
                    <span>पृष्ठ क्र : 1</span>
                </div>
                <div class="common" style="margin-left: 120px;">
                    <span>हिंदुस्थान प्रकाशन संस्था</span>
                    <span>विवेक साप्ताहिक</span>
                    <span>मुख्य खाते अनूपुस्तिका</span>
                </div>
            </div>
            <div class="row rowborder rowbordertop" style="gap: 0;">
                <div class="col-3 common">
                    <span>सांकेतांक</span>
                    <span>दिनांक</span>
                </div>
                <div class="col-3">
                    <span>तपशील : </span>
                    <span style="font-weight: bold;">{{bankname}}</span>
                </div>
                <div class="col-2 end">
                    <span>डेबिट</span>
                </div>
                <div class="col-2 end">
                    <span>क्रेडिट</span>
                </div>
                <div class="col-2 end">
                    <span>रक्कम</span>
                </div>
            </div>
            <div class="row rowborder rowbordertop">
                <div class="col-2">
                    <span></span>
                </div>
                <!-- <div class="col-1"></div> -->
                <div class="col-2">

                </div>
                <div class="col-2">
                    <span style="font-weight: bold;">मागील बाकी :</span>
                </div>
                <div class="col-2 end">
                    <span *ngIf="drOpeningBal !== 0" style="font-weight: bold;">
                        {{ (drOpeningBal * -1) | number:'1.2-2'}}
                    </span>

                </div>
                <div class="col-2 end">
                    <span *ngIf="crOpeningBal !== 0" style="font-weight: bold;">
                        {{ crOpeningBal | number:'1.2-2'}}
                    </span>
                </div>
            </div>
            <div class="row rowborder" *ngFor="let item of creditdebitledgerData">
                <div class="col-3 common">
                    <span>{{ item['voucher_no'] }}</span>
                    <span>{{ item['cheque'] }}</span>
                    <span>{{ item['voucher_date'] | date:"dd-MM-yyyy" }}</span>
                </div>
                <div class="col-3">
                    <span *ngIf="item['rep_name']">{{ item['rep_name'] }} <span style="font-size: 10px;"> {{
                            (item['other_name'])}}</span></span>
                    <!-- <span *ngIf="item['rep_name'] == ''">{{ item['other_name'] }}</span> -->
                </div>
                <div class="col-2 end">
                    <span *ngIf="item.type ==='DR'">{{ item['deposit_amt'] | number:'1.2-2'
                        }} </span>
                </div>
                <div class="col-2 end">
                    <span *ngIf="item.type === 'CR'">{{ item['deposit_amt'] | number:'1.2-2'
                        }}</span>
                </div>
                <div class="col-2 end">
                    <span *ngIf="item['total'] < 0">
                        {{ (item['total'] * -1) | number:'1.2-2' }} Dr
                    </span>
                    <span *ngIf="item['total'] >= 0">
                        {{ item['total'] | number:'1.2-2' }} Cr
                    </span>
                </div>
            </div>
            <div class="row rowborder rowbordertop" style="gap: 0;">
                <div class="col-4"></div>
                <div class="col-2 common" style="gap: 10px;">
                    <span>एकूण :</span>
                    <span>बाकी पुढे :</span>
                </div>
                <div class="col-2 common end">
                    <span style="padding-bottom: 5px;">{{ (debittotal * -1) | number:'1.2-2' }}</span>
                    <div class="line" *ngIf="nextbaki < 0"></div>
                    <span *ngIf="nextbaki < 0" style="padding-top: 5px;">
                        {{ (nextbaki * -1) | number:'1.2-2' }} Dr
                    </span>
                </div>
                <div class="col-2 end">
                    <span>{{ credittotal | number:'1.2-2'}}</span>
                    <div class="line" *ngIf="nextbaki > 0"></div>
                    <span *ngIf="nextbaki > 0" style="padding-top: 8%;">
                        {{ nextbaki | number:'1.2-2' }} Cr
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>